import { Search } from "@mui/icons-material";
import { Button, Divider, Grid, InputBase, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { IMetaData } from "../../../Components/Dialog/WSCommonDialog";
import Notes from "../../Notes/Notes";
import { openPopUp } from "../../../Components/Dialog/OpenNewModal";
import { callAPI, createObject, handleShare, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useNavigate, useParams } from "react-router-dom";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import ConfirmDialog, { useConfirmDialog } from "../../../Components/Confirmation/ConfirmDialog";

export const OverViewEstimation: React.FC<any> = React.memo((props) => {
    AllPermissions.getInstance();
    const { add, edit, remove, view } = AllPermissions.getEstimationPermission;

    const { showMessage } = useSnackbar();
    const dispatch = useDispatch()
    const { open, title, onConfirm, handleClose, openConfirmDialog, } = useConfirmDialog();
    const navigate = useNavigate();
    const params = useParams();
    const [estimatesData, setEstimatesData] = useState<any>([])
    const id = params?.id;
    const isMobile = IsSmallScreen();
    const [resetLoad, setResetLoad] = useState(false)
    useEffect(() => {

        const getEstimates = async () => {
            try {
                setResetLoad(false)
                const response: any = await callAPI(`estimates/lead/${id}`, Method.GET, null, null);
                setEstimatesData(response?.data);
            }
            catch (e) {

            }
        }
        getEstimates();
    }, [resetLoad])
    const columns: IColumns[] = [
        {
            header: "Name",
            fieldName: "customerName",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Amount",
            fieldName: "grandTotal",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined, "Convert to Quatation", "Print",
            remove ? "Delete" : undefined, "Share"].filter(Boolean),//"Convert to Work Order",
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const handleDelete = async (id?: string | number) => {
        const response: any = await callAPI(`estimates`, Method.DELETE, null, id);
        dispatch(resetDataComponent('estimateGrid'));
        setResetLoad(true)
        if (response?.success) {
            showMessage(response?.message, "success")
        }
        else {
            showMessage(response?.message || 'Something went wrong', "error")
        }
        handleClose()

    };
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`estimation/${row?.id}`)
        }
        else if (action === "Print") {
            navigate(`/estimation/print/${row?.id}`);
        }
        else if (action === 'Convert to Quatation') {
            navigate(`quatation/convert-quatation/${row?.id}`);

        }
        else if (action === "Delete") {
            openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
        }
        else if (action === 'Share') {
            handleShare(`/estimation/print/${row.id}`, 'Estimation');
        } else if (action === 'Convert to Work Order') {

            navigate(`order/estimation-convert-order/${row?.id}`);
        }

    }
    const source = {
        url: "estimates/search",
        page: 1,
        pageSize: 10,
        filter: [],
        sort: [],
    };

    const handleEstimateAddClick = () => {

        navigate(`estimation`)

    }
    return (
        <Grid>
            <Grid container spacing={2} sx={{ marginTop: 0 }}>

                {view ? <Grid item xs={12}>
                    <WSDataGrid
                        id="estimateGrid"
                        isAccordian={true}
                        title="Estimates"
                        columns={columns}
                        data={estimatesData}
                        gridHeaderSx={{
                            backgroundColor: "#751400",
                            border: "1px solid #751400",
                        }}
                        addButton={add ? { label: "New", color: "secondary" } : undefined}
                        addButtonBgClor={{ bg: '#751400', hovercolor: '#A31B00' }}
                        onAddButtonClick={handleEstimateAddClick}
                    />
                </Grid>
                    : <PermissionDenied />}
                <ConfirmDialog
                    open={open}
                    title={title}
                    onConfirm={onConfirm}
                    onClose={handleClose}
                />
            </Grid>
        </Grid>
    );
});
